import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';
import { LoggingMessageService } from './logging-message.service';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';


@Injectable({
  providedIn: 'root'
})
export class CacheService {

  private static cache: Map<any, any> = new Map<any, any>();
  private readonly maxAge;

  constructor(private authService: AuthService, private logger: LoggingMessageService) {
     this.logger.debug('cache.service', 'constructor', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString,'Creating new Cache', '');
    // CacheService.cache = new Map();
    this.maxAge = environment.CacheAge;
  }

  public get(req: HttpRequest<any>): HttpResponse<any> | undefined {
    const url = req.urlWithParams;

    //  this.logger.debug('', 'CacheService', 'GET - Before expiring old entries cache size:' + CacheService.cache.size);

    this.removeExpiredEntries();

    //  this.logger.debug('', 'CacheService', 'GET - After expiring old entries cache size:' + CacheService.cache.size);
    // CacheService.cache.forEach(entry => {
    //    this.logger.debug('', 'CacheService', `GET - cache now contains: ${entry.url}`);
    // });

    const cached = CacheService.cache.get(url);

    // if (isCacheValid) {
    if (cached) {
       this.logger.debug('cache.service', 'get', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString,`Found client cached response:${url}`, '');
      return cached.response;
    } else {
      // this.logger.info('', 'CacheService', 'NOT Found client cached response:' + url);
    }

    return undefined;
  }

  public put(req: HttpRequest<any>, response: HttpResponse<any>): void {
    const url = req.url;
    const entry = { url, response, lastRead: Date.now() };
    this.logger.info('cache.service', 'put', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, `Adding response to client cache: ${entry.url}`, '');
    CacheService.cache.set(url, entry);

    //  this.logger.debug('', 'CacheService', 'PUT - Before expiring old entries cache size:' + CacheService.cache.size);
    this.removeExpiredEntries();
    //  this.logger.debug('', 'CacheService', 'PUT - After expiring old entries cache size:' + CacheService.cache.size);
  }

  public clearCache() {
    CacheService.cache.clear();
  }

  private removeExpiredEntries() {
    const expired = Date.now() - this.maxAge;
    CacheService.cache.forEach(expiredEntry => {
      if (expiredEntry.lastRead < expired) {
         this.logger.debug('cache.service', 'removeExpiredEntries', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString,`Removing expired response from client cache:${expiredEntry.url}`, '');
        CacheService.cache.delete(expiredEntry.url);
      }
    });
  }
}
